module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/SCsqG7/tc-custom/9781911420491.jpg?1724535926064",
      "alt": "This image is the cover for the book Insurrection, An Agent Paul Richter Thriller"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Insurrection, An Agent Paul Richter Thriller\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("An action-packed espionage techno-thriller featuring a British intelligence agent who must stop a terrorist attack on the United States.")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Maverick British agent Paul Richter returns in his most dangerous mission yet."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" In Syria, a ritualistic ISIS beheading seems like another barbaric part of a terrible war. But this time is different . . ."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" In London, Paul Richter is briefed about a series of apparently unconnected events, notably a terrifying spate of seemingly random shootings in America. Something doesn’t quite fit. Before long Richter is on the case and in the line of fire."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" It seems a plot far bigger than anyone could have imagined is brewing from the mountains of the Hindu Kush and the deserts of Syria to the heart of Middle America."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" With no information, the clock is ticking for Richter—and millions of innocent lives."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" For readers of James Patterson, Will Jordan and Chris Ryan, the Agent Paul Richter series is intense, visceral and totally unmissable."), _c('br')]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      James Barrington\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Canelo Digital Publishing Limited\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0